import { useState, useCallback } from 'react';
import { getDevice } from '../apis';

export const useDevice = () => {
  const [device, setDevice] = useState<Device>({ name: '', detail: '', interval: 0, capture_fps: 0, roi_lable_name: '', roi_lable_note1: '', roi_lable_note2: '', audit_keep_days: 0, ng_to_ok_threshold: 0, ok_to_ng_threshold: 0  });
  const [deviceLoading, setLoading] = useState<boolean>(true);
  const [message, setMessage] = useState('');
  const [error, setError] = useState<string>('');
  const [status_code, setStatusCode] = useState<string>('');

  const fetchDevice = useCallback(async () => {
    setLoading(true);
    getDevice()
      .then(res => {
        const { data: { data } } = res;
        setDevice(data);
        setStatusCode(res.data.status_code);
        setMessage(res.data.message)
        setLoading(false);
      })
      .catch(error => {
        console.log(error);
        setError(error);
      });
  }, []);

  return { state: { device, deviceLoading, error, message, status_code }, actions: { fetchDevice, setDevice } };
};

export interface Device {
  name: string,
  detail: string,
  interval: number,
  capture_fps: number,
  roi_lable_name: string
  roi_lable_note1: string,
  roi_lable_note2: string,
  audit_keep_days: number,
  ng_to_ok_threshold: number,
  ok_to_ng_threshold: number,
}